export default __webpack_public_path__ + "static/media/icon_one.aa683b8a.svg";